export default __webpack_public_path__ + "static/media/manual-hover.da61c954.svg";